import { inject, Injectable, NgZone } from '@angular/core';
import OpenReplay from '@openreplay/tracker';
import trackerAssist from '@openreplay/tracker-assist';
import { HttpRequest, HttpResponse } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class OpenReplayService {
  private tracker?: OpenReplay | null;

  private readonly _ngZone = inject(NgZone);

  get isActive(): boolean {
    return !!this.tracker && this.tracker.isActive();
  }

  constructor() {
    this._ngZone.runOutsideAngular(() => {
      this.tracker = new OpenReplay({
        projectKey: environment.openReplay.projectKey,
        network: { capturePayload: true } as any,
        __DISABLE_SECURE_MODE: !environment.production,
        mouse: { disableClickmaps: false }
      });

      this.tracker.use(
        trackerAssist({ confirmText: `You have an incoming call from <Company> Support. Do you want to answer?` })
      );
    });
  }

  public start() {
    return this._ngZone.runOutsideAngular(() => {
      if (this.tracker) {
        return this.tracker.start();
      } else {
        return {
          sessionID: null,
          sessionToken: null,
          userUUID: null
        };
      }
    });
  }

  public setUser(email: string) {
    this.tracker?.setUserID(email);
  }

  public stop() {
    this.tracker?.stop();
    this.tracker = undefined;
  }

  public sendEventToReplaySession(event: string, params: {
    request: HttpRequest<unknown>,
    response: HttpResponse<unknown>
  }): void {
    const { request, response } = params;

    this.tracker?.event(`${event}[request]`, {
      method: request.method,
      url: request.url,
      params: request.params
    });

    this.tracker?.event(`${event}[response]`, {
      body: response.body,
      status: response.status,
      headers: response.headers
    });

  }

  public reportIssue(title: string, description: string): void {
    this._ngZone.runOutsideAngular(() => {
      this.tracker?.issue(title, description);
      const now = Date.now();
      this.tracker?.incident({ label: `${title} - ${description}`, startTime: now - (10 * 60000), endTime: now });
    });
  }


}
